export const getBoundingBoxes = ({
  positionalText,
  highlightBlockIds,
  highlightBlockScores,
  attributeSources,
  isShowExtractedWords,
  isForceShowHighlightBlocks,
  seeSourceAttributeSlug
}) => {
  if (
    !positionalText ||
    positionalText.length === 0 ||
    typeof highlightBlockIds === "undefined" ||
    typeof highlightBlockScores === "undefined" ||
    typeof attributeSources === "undefined"
  ) {
    return []
  }

  const boxes = []
  for (const item of positionalText[0].content) {
    let isInclude = false
    let color = "rgba(88, 8, 248, 1)"

    if (isShowExtractedWords) isInclude = true

    if (typeof seeSourceAttributeSlug !== "undefined") {
      if (Array.isArray(attributeSources)) {
        const matchingSource = attributeSources.find(source => source.ocr_block_id === item.id)
        if (matchingSource) {
          isInclude = true
          color = matchingSource.ocr_block_score === 1 ? "red" : "orange"
        }
      }
    }

    // isForceShowHighlightBlocks is disabled when in see source mode
    if (isForceShowHighlightBlocks && typeof seeSourceAttributeSlug === "undefined") {
      const blockIndex = highlightBlockIds.indexOf(item.id)
      if (blockIndex !== -1) {
        isInclude = true
        color = highlightBlockScores[blockIndex] === 1 ? "red" : "orange"
      }
    }

    if (isInclude) {
      const topLeftX = item.content[0]
      const topLeftY = item.content[1]
      const width = item.content[2]
      const height = item.content[3]

      boxes.push({
        id: item.id,
        word: item.content[4],
        boundingBox: [
          {
            x: topLeftX,
            y: topLeftY
          },
          {
            x: topLeftX + width,
            y: topLeftY
          },
          {
            x: topLeftX + width,
            y: topLeftY + height
          },
          {
            x: topLeftX,
            y: topLeftY + height
          }
        ],
        color
      })
    }
  }

  return boxes
}

export const getTopHighlightBlockId = ({ highlightBlockIds, highlightBlockScores }) => {
  if (typeof highlightBlockIds === "undefined" || typeof highlightBlockScores === "undefined") {
    return undefined
  }

  let id = undefined
  let topScore = 0
  for (let i = 0; i < highlightBlockIds.length; i++) {
    const score = highlightBlockScores[i] // eslint-disable-line
    if (score > topScore) {
      id = highlightBlockIds[i] // eslint-disable-line
      topScore = score
    }

    if (score === 1) break
  }

  return id
}
